import { render, staticRenderFns } from "./NewProfileEdit.vue?vue&type=template&id=3eadabd5&scoped=true"
import script from "./NewProfileEdit.vue?vue&type=script&lang=js"
export * from "./NewProfileEdit.vue?vue&type=script&lang=js"
import style0 from "./NewProfileEdit.vue?vue&type=style&index=0&id=3eadabd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eadabd5",
  null
  
)

export default component.exports